export default "__VITE_ASSET__69eb2aab__"